'use strict';

var jquery = require('jquery');
global.$ = jquery;
global.jQuery = jquery;
window.jQuery = jquery;
window.$ = jquery;

var processInclude = require('base/util');

$(document).ready(function () {
    processInclude(require('./components/stickyTopNav'));
    processInclude(require('base/components/cookie'));
    processInclude(require('lyonscg/components/scanbarcode'));
    processInclude(require('./components/miniCartBasic'));
    processInclude(require('base/components/collapsibleItem'));
    processInclude(require('./components/search'));
    processInclude(require('./components/clientSideValidation'));
    processInclude(require('./components/carousels'));
    if ($('#loadHOPSJS').val() === 'true') {
        processInclude(require('aws/hops'));
    }
    processInclude(require('./components/input'));
    processInclude(require('./components/modal'));
    processInclude(require('./components/injectDynamicCss'));
    processInclude(require('./wisTulsa/wisTulsa'));
    processInclude(require('./pageHeader'));
    processInclude(require('./tradeinOverlay'));
    processInclude(require('./appsession/keepAlive'));
    processInclude(require('./mobileAppUtils'));
    processInclude(require('./components/footerSignup'));
    processInclude(require('./tileRender'));
    processInclude(require('./transparentTileRender'));
    var tagManager = require('int_googletags/tagManager');
    tagManager.init(window.pageContext && window.pageContext.ns);
    processInclude(require('./breadFinancialHelpers'));
});

require('./thirdParty/bootstrap');
require('base/components/spinner');
require('./util/getSafeValue');
require('svg4everybody');
require('slick-carousel');
require('./thirdParty/jquery-visible');
require('./thirdParty/lazysizes.min');
